const WineGlassIcon = () => {
  return (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Glass bowl */}
      <path 
        d="M24 8 C24 8, 22 18, 22 28 C22 36, 26 42, 32 46 L32 46 C34 47, 36 48, 38 48.5 L38 64 M42 48.5 C44 48, 46 47, 48 46 C54 42, 58 36, 58 28 C58 18, 56 8, 56 8" 
        stroke="#C9A961" 
        strokeWidth="2.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* Glass rim */}
      <path 
        d="M24 8 L56 8" 
        stroke="#C9A961" 
        strokeWidth="2.5" 
        strokeLinecap="round"
      />
      
      {/* Stem */}
      <path 
        d="M40 48.5 L40 64" 
        stroke="#C9A961" 
        strokeWidth="3" 
        strokeLinecap="round"
      />
      
      {/* Base */}
      <path 
        d="M30 64 L50 64" 
        stroke="#C9A961" 
        strokeWidth="2.5" 
        strokeLinecap="round"
      />
      <ellipse 
        cx="40" 
        cy="64" 
        rx="10" 
        ry="1.5" 
        fill="#C9A961" 
        opacity="0.3"
      />
      
      {/* Wine liquid */}
      <path 
        d="M25 22 C25 22, 28 24, 32 25.5 C36 27, 44 27, 48 25.5 C52 24, 55 22, 55 22 L55 28 C55 33, 52 37, 48 40 C44 43, 36 43, 32 40 C28 37, 25 33, 25 28 Z" 
        fill="#C9A961"
        opacity="0.25"
      />
      
      {/* Wine surface highlight */}
      <ellipse 
        cx="40" 
        cy="24" 
        rx="15" 
        ry="3" 
        fill="#C9A961"
        opacity="0.4"
      />
      
      {/* Glass shine */}
      <path 
        d="M28 12 Q30 16, 30 22" 
        stroke="#C9A961" 
        strokeWidth="1.5" 
        strokeLinecap="round"
        opacity="0.4"
      />
    </svg>
  );
};

export default WineGlassIcon;
